import Router from 'next/router';

import { resolveInternalRedirect } from 'helpers/resolve-internal-redirect';

type RouterOptions = {
    shallow?: boolean;
    locale?: string | false;
    scroll?: boolean;
    validate?: boolean;
};

const RouterService = {
    push: async (url: string, as?: string, { validate = true, ...options }: RouterOptions = {}): Promise<void> => {
        if (validate) {
            return RouterService.push(resolveInternalRedirect(url), as, { ...options, validate: false });
        }

        if (Router.router === null) {
            window.location.assign(url);

            return;
        }

        await Router.push(url, as, options);
    },

    replace: async (url: string, as?: string, { validate = true, ...options }: RouterOptions = {}): Promise<void> => {
        if (validate) {
            return RouterService.replace(resolveInternalRedirect(url), as, { ...options, validate: false });
        }

        if (Router.router === null) {
            window.location.replace(url);

            return;
        }

        await Router.replace(url, as, options);
    },

    refresh: async () => {
        if (Router.router === null) {
            window.location.reload();

            return;
        }

        await Router.replace(Router.asPath);
    },

    reload: () => {
        if (Router.router === null) {
            window.location.reload();

            return;
        }

        Router.reload();
    },

    back: () => {
        Router.back();
    },

    setQuery: async (name: string, value: string, action: 'replace' | 'push' = 'push') => {
        const search = new URLSearchParams(window.location.search);
        search.set(name, value);

        let url = window.location.pathname;

        if (search.toString()) {
            url += `?${search.toString()}`;
        }

        if (window.location.hash) {
            url += window.location.hash;
        }

        await RouterService[action](url, undefined, { shallow: true });
    },

    removeQuery: async (name: string, action: 'replace' | 'push' = 'replace') => {
        const search = new URLSearchParams(window.location.search);
        search.delete(name);

        let url = window.location.pathname;

        if (search.toString()) {
            url += `?${search.toString()}`;
        }

        if (window.location.hash) {
            url += window.location.hash;
        }

        await RouterService[action](url, undefined, { shallow: true });
    },
};

export { RouterService };
